import React   from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Route, Navigate, Outlet } from 'react-router-dom'

import { isLoggedIn } from './SecurityController'
import { reset } from './../Redux/features/authSlice'

const PrivateRoute = ({ children })  => {
		const dispatch = useDispatch();
        const { user } = useSelector((state) => state.auth)
        //console.log('redux > user : ', user )
		
		if(!isLoggedIn(user)) {
            
            //console.log('redux > user NOT LOGIN .... reset ....' )
			// Reset the redux auth data 
			dispatch(reset())

			return <Navigate to={`/login`} replace />;
		}

		return children ? children : <Outlet />;
};



export default PrivateRoute;
